// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.ferm_parameter_kind_enum */
var FermParameterKindEnum;
(function (FermParameterKindEnum) {
    FermParameterKindEnum["NUMBER"] = "NUMBER";
    FermParameterKindEnum["TEXT"] = "TEXT";
    FermParameterKindEnum["CHECKBOX"] = "CHECKBOX";
})(FermParameterKindEnum || (FermParameterKindEnum = {}));
;
export default FermParameterKindEnum;
/** Zod schema for ferm_parameter_kind_enum */
export const fermParameterKindEnum = z.nativeEnum(FermParameterKindEnum);
//# sourceMappingURL=FermParameterKindEnum.js.map